export default __webpack_public_path__ + "static/driverecorderLeaflet-8fb7e0af8950573b1d4d9e547ec8fc08.pdf";